import { TFunction } from "@impero-com/common/utils/i18n";
import { rawPalette } from "@impero-com/ui/styles/theme.css";

import { ActivityFrictionCounts } from "api/generated/model";

export type ActivityHealthLevel = keyof ActivityFrictionCounts;

export interface ActivityHealthLevelSpec {
    key: ActivityHealthLevel;
    label: (t: TFunction) => string;
    color: string;
}

export const ACTIVITY_HEALTH_LEVELS: ActivityHealthLevelSpec[] = [
    {
        key: "highFriction",
        label: (t) => t("ControlResult_Friction_HighFriction"),
        color: rawPalette.health.highFriction,
    },
    {
        key: "friction",
        label: (t) => t("ControlResult_Friction_Friction"),
        color: rawPalette.health.friction,
    },
    {
        key: "noFriction",
        label: (t) => t("ControlResult_Health_Clean"),
        color: rawPalette.health.noFriction,
    },
];

export function sumActivityCounts(counts: ActivityFrictionCounts): number {
    return counts.noFriction + counts.friction + counts.highFriction;
}
